module.exports = __webpack_public_path__ + "static/media/spaceman.a5900e86.gif";